import i18n from 'i18next';

import {apiClient} from 'core/apiClient';

import {
    ChangePasswordRequest,
    MfaRequest,
    MfaVerifyRequest,
    SetPasswordParams,
    SetPasswordRequest,
} from 'types/password';

const URL = '/uaa/web/mfa';
const PASSWORD_URL = `${URL}/password`;
const LANGUAGE_HEADERS_PRESET = () => ({headers: {'Accept-Language': i18n.language}});

export async function createPasswordRequest(body: SetPasswordRequest) {
    const path = `${PASSWORD_URL}/request/create`;
    return (await apiClient.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function resetPasswordRequest(body: SetPasswordRequest) {
    const path = `${PASSWORD_URL}/request/reset`;
    return (await apiClient.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function resetPasswordByAdminRequest(body: SetPasswordRequest) {
    const path = `${PASSWORD_URL}/request/reset-admin`;
    return (await apiClient.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function changePassword(body: ChangePasswordRequest) {
    const path = `${PASSWORD_URL}/change`;
    return (await apiClient.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function setPassword(body: SetPasswordParams) {
    const path = `${PASSWORD_URL}/create`;
    return (await apiClient.post(path, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function createMfaSession(body: MfaRequest) {
    return (await apiClient.post<string>(URL, body, LANGUAGE_HEADERS_PRESET())).data;
}

export async function verifyMfaSession(body: MfaVerifyRequest) {
    return (await apiClient.post(`${URL}/verify`, body, LANGUAGE_HEADERS_PRESET())).data;
}
